/** Casas decimais dos valores de indicador na tela e nos arquivos exportados. */
export const INDICATOR_FRACTION_DIGITS = 1;

/** `6` e `6,04` viram `6,0`; `6,05` vira `6,1`. */
export function formatIndicatorNumber(value: number, locale = 'pt-BR'): string {
  return value.toLocaleString(locale, {
    minimumFractionDigits: INDICATOR_FRACTION_DIGITS,
    maximumFractionDigits: INDICATOR_FRACTION_DIGITS,
  });
}
